/* global window */

import log from 'loglevel';

import Sailthru from './Sailthru';
import Braze from './Braze';
import PIP from './PIP';
import MediaOS from './MediaOS';

/**
 * Sync user ID before starting a Braze session.
 * @param {Object} sailthru - Sailthru instance.
 * @param {Object} braze - Braze instance.
 * @param {Object} pip - PIP instance.
 */
function syncUserVeryLocal(sailthru, braze, pip) {
  if (!sailthru.isSailthruReady || !braze.isBrazeReady) {
    return;
  }

  sailthru.fetchCurrentUserData()
    .then(() => braze.changeUser(sailthru.userEmailHash))
    .then(() => braze.fetchCurrentUserData())
    .then(() => braze.openSession())
    .then(() => pip.getUserLocationPermissionStatus())
    .then(() => pip.getUserLocation())
    .then(() => pip.getUserNeighborhoods())
    .then(() => braze.setLastKnownLocation(pip.location, pip.neighborhoods))
    .then(() => braze.pushRequest())
    .catch(error => log.error(error));
}

/**
 * Sync user ID before starting a Braze session.
 * @param {Object} sailthru - Sailthru instance.
 * @param {Object} braze - Braze instance.
 * @param {Object} pip - PIP instance.
 */
function syncUserMediaOS(sailthru, braze, pip) {
  if (!sailthru.isSailthruReady || !braze.isBrazeReady) {
    return;
  }

  sailthru.fetchCurrentUserData()
    .then(() => braze.changeUser(sailthru.userEmailHash))
    .then(() => braze.fetchCurrentUserData())
    .then(() => braze.openSession())
    .then(() => pip.getUserLocationPermissionStatus())
    .then(() => pip.getUserLocation())
    .then(() => pip.getUserNeighborhoods())
    .then(() => braze.setLastKnownLocation(pip.location, pip.neighborhoods))
    .then(() => MediaOS.updateWeather(pip.location))
    .then(() => braze.pushRequest())
    .catch(error => log.error(error));
}

/**
 * Load and initialize required scripts.
 */
function bootstrap() {
  const sailthru = new Sailthru();
  const braze = new Braze();
  const pip = new PIP();
  const components = [sailthru, braze, pip];

  if (window.METAPHOR_DISABLED) {
    return;
  }

  Promise.all(components.map(component => component.load()))
    .then(() => {
      components.map(component => component.init());

      if (window.VLCL) {
        syncUserVeryLocal(sailthru, braze, pip);
      }

      if (window.HRST) {
        syncUserMediaOS(sailthru, braze, pip);
      }
    })
    .catch(error => log.error(error));
}

export default bootstrap;



// WEBPACK FOOTER //
// ./src/bootstrap.js